var _excluded = ["to", "href", "title", "onClick", "onMouseEnter", "onMouseLeave", "openInNewTab", "rel", "isBold", "children"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
import React, { useContext } from "react";
import styled, { css } from "styled-components";
import OnColorContext from "../../../contexts/OnColorContext";
import TypographyContext from "../../../contexts/TypographyContext";
import breakpoint from "../../../utils/breakpoint";
import throwError from "../../../utils/throwError";
import Link from "../../quarks/Link";
import { cssTextAtm } from "../TextAtm/TextAtm.styled";
var StyledNestedLinkAtm = styled(Link).withConfig({
  componentId: "sc-116hymh-0"
})(function (_ref) {
  var $isBold = _ref.$isBold,
    $inheritedTypography = _ref.$inheritedTypography,
    $onColor = _ref.$onColor;
  return css(["color:inherit;text-decoration:underline;cursor:pointer;", ""], $isBold && css(["", " ", " &:hover{text-decoration:none;}"], _typeof($inheritedTypography) === "object" && "\n        ".concat(cssTextAtm({
    typography: $inheritedTypography.small,
    onColor: $onColor,
    isBold: true
  }), ";\n\n        ").concat(breakpoint("medium"), " {\n          ").concat(cssTextAtm({
    typography: $inheritedTypography.medium,
    onColor: $onColor,
    isBold: true
  }), ";\n        }\n\n        ").concat(breakpoint("large"), " {\n          ").concat(cssTextAtm({
    typography: $inheritedTypography.large,
    onColor: $onColor,
    isBold: true
  }), ";\n        }\n      "), typeof $inheritedTypography === "string" && css(["", ""], cssTextAtm({
    typography: $inheritedTypography,
    onColor: $onColor,
    isBold: true
  }))));
});
function NestedLinkAtm(_ref2) {
  var to = _ref2.to,
    href = _ref2.href,
    title = _ref2.title,
    onClick = _ref2.onClick,
    onMouseEnter = _ref2.onMouseEnter,
    onMouseLeave = _ref2.onMouseLeave,
    openInNewTab = _ref2.openInNewTab,
    rel = _ref2.rel,
    isBold = _ref2.isBold,
    children = _ref2.children,
    restProps = _objectWithoutProperties(_ref2, _excluded);
  var inheritedTypography = useContext(TypographyContext);
  var onColor = useContext(OnColorContext);
  if (!inheritedTypography) {
    return throwError("<NestedLinkAtm> must be placed inside <TextAtm>!");
  }
  return /*#__PURE__*/React.createElement(StyledNestedLinkAtm, _extends({
    to: to,
    href: href,
    title: title,
    onClick: onClick,
    onMouseEnter: onMouseEnter,
    onMouseLeave: onMouseLeave,
    openInNewTab: openInNewTab,
    rel: rel,
    $isBold: !!isBold,
    $inheritedTypography: inheritedTypography,
    $onColor: onColor
  }, restProps), children);
}
export default NestedLinkAtm;